module.exports = __webpack_public_path__ + "media/signup-react/cleaner-fe99482f.png";